/**
 * PDP Buy Box — scoped per section instance (safe to reuse on same page).
 */
(function () {
  'use strict';

  var STICKY_HYSTERESIS = 32;

  function getCartItemFromOffer(root, card) {
    var variantId =
      (card && card.dataset.variantId) || root.dataset.defaultVariantId || '';
    if (!variantId) return null;

    var quantity = parseInt((card && card.dataset.quantity) || '1', 10);
    if (!quantity || quantity < 1) quantity = 1;

    var item = { id: Number(variantId), quantity: quantity };
    var purchaseType = card && card.dataset.purchaseType;
    var sellingPlanId = card && card.dataset.sellingPlanId;

    if (purchaseType !== 'onetime' && sellingPlanId) {
      item.selling_plan = Number(sellingPlanId);
    }

    return item;
  }

  function setButtonsLoading(buttons, loading) {
    buttons.forEach(function (btn) {
      btn.disabled = loading;
      btn.classList.toggle('is-loading', loading);
      if (loading) {
        btn.setAttribute('aria-busy', 'true');
      } else {
        btn.removeAttribute('aria-busy');
      }
    });
  }

  function getCheckoutButtons(root) {
    var buttons = Array.from(
      root.querySelectorAll('[data-sk-add-to-cart], [data-sk-sticky-add-to-cart]')
    );
    var stickyOuter = document.getElementById('sk-sticky-atc-' + root.dataset.sectionId);

    if (stickyOuter) {
      var stickyButton = stickyOuter.querySelector('[data-sk-sticky-add-to-cart]');
      if (stickyButton && buttons.indexOf(stickyButton) === -1) {
        buttons.push(stickyButton);
      }
    }

    return buttons;
  }

  function showCheckoutError(root, show) {
    var el = root.querySelector('[data-sk-checkout-error]');
    if (!el) return;
    el.hidden = !show;
  }

  function clearCartDiscounts() {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      credentials: 'same-origin',
      body: JSON.stringify({ discount: '' }),
    }).catch(function () {});
  }

  function expireDiscountCookies() {
    document.cookie.split(';').forEach(function (part) {
      var name = (part.split('=')[0] || '').trim();
      if (!name || name.toLowerCase().indexOf('discount') === -1) return;
      document.cookie =
        name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax';
    });

    ['sessionStorage', 'localStorage'].forEach(function (storageName) {
      try {
        var storage = window[storageName];
        if (!storage) return;
        Object.keys(storage).forEach(function (key) {
          if (key.toLowerCase().indexOf('discount') !== -1) {
            storage.removeItem(key);
          }
        });
      } catch (_) {}
    });
  }

  function shouldApplyCoupon(root, activeCard) {
    if (!root.dataset.couponCode || !root.dataset.couponCode.trim()) return false;
    if (!activeCard) return false;
    if (activeCard.dataset.purchaseType === 'onetime') return false;
    if (
      activeCard.dataset.purchaseType === 'subscription' &&
      activeCard.dataset.quantity === '1'
    ) {
      return false;
    }
    return true;
  }

  function submitDirectCheckout(cartItem, checkoutPath) {
    var form = document.createElement('form');
    form.method = 'post';
    form.action = '/cart/add';
    form.style.display = 'none';

    var fields = {
      id: cartItem.id,
      quantity: cartItem.quantity || 1,
      return_to: checkoutPath,
    };
    if (cartItem.selling_plan) {
      fields.selling_plan = cartItem.selling_plan;
    }

    Object.keys(fields).forEach(function (key) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = fields[key];
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
  }

  function performCheckout(root, buttons) {
    var activeCard = root.querySelector('.sk-offer-card.active');
    var cartItem = getCartItemFromOffer(root, activeCard);

    if (!cartItem) {
      var fallbackVariantId = root.dataset.defaultVariantId;
      if (!fallbackVariantId) return;
      cartItem = { id: Number(fallbackVariantId), quantity: 1 };
    }

    setButtonsLoading(buttons, true);
    showCheckoutError(root, false);

    var couponCode = shouldApplyCoupon(root, activeCard)
      ? root.dataset.couponCode.trim()
      : '';
    var checkoutPath = couponCode
      ? '/checkout?discount=' + encodeURIComponent(couponCode)
      : '/checkout';

    fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart clear failed');
        expireDiscountCookies();
        return clearCartDiscounts();
      })
      .then(function () {
        submitDirectCheckout(cartItem, checkoutPath);
      })
      .catch(function () {
        setButtonsLoading(buttons, false);
        showCheckoutError(root, true);
      });
  }

  function getStickyHeaderOffset() {
    var headerGroup = document.getElementById('header-group');
    if (headerGroup) {
      return Math.ceil(headerGroup.getBoundingClientRect().height);
    }

    var header = document.querySelector('#header-component, .header');
    return header ? Math.ceil(header.getBoundingClientRect().height) : 0;
  }

  function formatStickyPromoBadge(text) {
    return text.replace(/(\$[\d]+)\.00\b/g, '$1');
  }

  function getOfferPlanTitle(card) {
    if (!card) return '';

    if (card.dataset.stickyTitle) {
      return card.dataset.stickyTitle.trim();
    }

    var offerTitle = card.querySelector('.sk-offer-title');
    if (!offerTitle) return '';

    return offerTitle.childNodes[0] && offerTitle.childNodes[0].textContent
      ? offerTitle.childNodes[0].textContent.trim()
      : offerTitle.textContent.trim();
  }

  // function isStickyViewport(root) {
  //   if (root.dataset.stickyMobileOnly === 'true') {
  //     return window.matchMedia('(max-width: 749px)').matches;
  //   }
  //   return true;
  // }
  function isStickyViewport(root) {
    // Enable on desktop & mobile exclusively for Gut Balance US 3 template
    if (document.body.classList.contains('template-gut-balance-us4')) {
      return true;
    }

    if (root.dataset.stickyMobileOnly === 'true') {
      return window.matchMedia('(max-width: 749px)').matches;
    }
    return true;
  }

  function isBuyBoxInView(root) {
    var shopSection = root.querySelector('.skg-shop') || root;
    var rect = shopSection.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    return rect.top < viewportHeight && rect.bottom > 0;
  }

  function isFooterInView() {
    var footer = document.querySelector('[data-sk-section="footer"]');
    if (!footer) return false;
    var rect = footer.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    return rect.top < viewportHeight && rect.bottom > 0;
  }

  function stripSecondKindPrefix(name) {
    return (name || '').replace(/^SecondKind\s*[·\-\u2013\u2014]\s*/i, '').trim();
  }

  function syncStickyBar(root) {
    if (root.dataset.showStickyAddToCart !== 'true') return;

    var stickyOuter = document.getElementById('sk-sticky-atc-' + root.dataset.sectionId);
    if (!stickyOuter) return;

    var activeCard = root.querySelector('.sk-offer-card.active');
    var titleEl = stickyOuter.querySelector('.sk-sticky-atc__title');
    var priceCurrent = stickyOuter.querySelector('.sk-sticky-atc__price-current');
    var priceCompare = stickyOuter.querySelector('.sk-sticky-atc__price-compare');
    var subtitle = stickyOuter.querySelector('[data-sk-sticky-subtitle]');
    var promoBadge = stickyOuter.querySelector('.sk-sticky-atc__promo-badge');

    if (!activeCard) return;

    var offerPrice = activeCard.querySelector('.sk-offer-price');
    var offerStrike = activeCard.querySelector('.sk-offer-strike');

    if (titleEl) {
      var planTitle = getOfferPlanTitle(activeCard);

      if (root.dataset.stickyMobileOnly === 'true') {
        if (planTitle) {
          titleEl.textContent = planTitle;
        } else {
          titleEl.textContent = stripSecondKindPrefix(root.dataset.stickyProductName || '');
        }
      } else if (planTitle) {
        var productName = root.dataset.stickyProductName || '';
        titleEl.textContent = productName && planTitle
          ? productName + ' - ' + planTitle
          : planTitle || productName;
      } else {
        titleEl.textContent = root.dataset.stickyProductName || '';
      }
    }

    if (promoBadge) {
      var promoBadgeText = root.dataset.stickyMobileOnly === 'true'
        ? (activeCard.dataset.stickyPromoBadge ? activeCard.dataset.stickyPromoBadge.trim() : '')
        : (activeCard.querySelector('.sk-offer-save')
          ? activeCard.querySelector('.sk-offer-save').textContent.trim()
          : '');

      if (promoBadgeText) {
        promoBadge.textContent = formatStickyPromoBadge(promoBadgeText);
        promoBadge.hidden = false;
        promoBadge.removeAttribute('hidden');
      } else {
        promoBadge.textContent = '';
        promoBadge.hidden = true;
        promoBadge.setAttribute('hidden', '');
      }
    }

    if (priceCurrent) {
      var stickyPrice = activeCard.dataset.stickyPrice;
      if (stickyPrice) {
        priceCurrent.textContent = stickyPrice;
      } else if (offerPrice) {
        priceCurrent.textContent = offerPrice.textContent.trim();
      }
    }

    if (priceCompare) {
      var stickyCompare = activeCard.dataset.stickyCompare;
      if (stickyCompare) {
        priceCompare.textContent = stickyCompare;
        priceCompare.hidden = false;
      } else if (offerStrike && offerStrike.textContent.trim()) {
        priceCompare.textContent = offerStrike.textContent.trim();
        priceCompare.hidden = false;
      } else {
        priceCompare.textContent = '';
        priceCompare.hidden = true;
      }
    }

    if (subtitle) {
      subtitle.textContent = '';
      subtitle.hidden = true;
    }
  }

  function initStickyBar(root) {
    if (root.dataset.showStickyAddToCart !== 'true') return;

    var stickyOuter = document.getElementById('sk-sticky-atc-' + root.dataset.sectionId);
    if (!stickyOuter || stickyOuter.dataset.skStickyInit === 'true') return;

    var anchor = root.querySelector('[data-sk-atc-anchor]');
    if (!anchor && root.dataset.stickyMobileOnly !== 'true') return;

    stickyOuter.dataset.skStickyInit = 'true';

    if (stickyOuter.parentElement !== document.body) {
      document.body.appendChild(stickyOuter);
    }

    stickyOuter.removeAttribute('hidden');
    stickyOuter.setAttribute('aria-hidden', 'true');
    stickyOuter.classList.remove('is-active');

    var stickyInner = stickyOuter.querySelector('.sk-sticky-atc__inner');
    var stickyButton = stickyOuter.querySelector('[data-sk-sticky-add-to-cart]');
    var isActive = false;
    var stickyRaf = null;

    function updateStickyVisibility() {
      if (!isStickyViewport(root)) {
        isActive = false;
        stickyOuter.classList.remove('is-active');
        stickyOuter.setAttribute('aria-hidden', 'true');
        return;
      }

      if (root.dataset.stickyMobileOnly === 'true') {
        isActive = !isBuyBoxInView(root) && !isFooterInView();
        stickyOuter.classList.toggle('is-active', isActive);
        stickyOuter.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        return;
      }

      if (!anchor) return;

      var headerOffset = getStickyHeaderOffset();
      var anchorTop = anchor.getBoundingClientRect().top;
      var shouldShow = false;

      if (!isActive) {
        shouldShow = anchorTop < headerOffset;
      } else {
        shouldShow = anchorTop < headerOffset - STICKY_HYSTERESIS;
      }

      isActive = shouldShow;
      stickyOuter.classList.toggle('is-active', isActive);
      stickyOuter.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    }

    function onStickyScroll() {
      if (stickyRaf !== null) return;
      stickyRaf = window.requestAnimationFrame(function () {
        stickyRaf = null;
        updateStickyVisibility();
      });
    }

    if (stickyInner) {
      stickyInner.addEventListener('click', function (event) {
        if (stickyButton && stickyButton.classList.contains('is-loading')) return;
        if (stickyButton && stickyButton.disabled) return;
        if (event.target.closest('[data-sk-sticky-add-to-cart]')) return;
        event.preventDefault();
        stickyButton && stickyButton.click();
      });
    }

    if (stickyButton) {
      stickyButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (stickyButton.classList.contains('is-loading')) return;
        var buttons = getCheckoutButtons(root);
        performCheckout(root, buttons);
      });
    }

    window.addEventListener('scroll', onStickyScroll, { passive: true });
    window.addEventListener('resize', onStickyScroll, { passive: true });

    stickyOuter.__skStickyCleanup = function () {
      window.removeEventListener('scroll', onStickyScroll);
      window.removeEventListener('resize', onStickyScroll);
      if (stickyRaf !== null) window.cancelAnimationFrame(stickyRaf);
    };

    syncStickyBar(root);
    onStickyScroll();
  }

  function placeReviewsCarousel(root) {
    var carousel = root.querySelector('[data-sk-pdp-reviews-carousel]');
    var gallery = root.querySelector('.sk-gallery');
    var bullets = root.querySelector('.sk-buybox-bullets');
    if (!carousel || !gallery || !bullets) return;

    var isMobile = window.matchMedia('(max-width: 880px)').matches;
    if (isMobile) {
      if (carousel.parentElement !== bullets.parentElement || carousel.previousElementSibling !== bullets) {
        bullets.insertAdjacentElement('afterend', carousel);
      }
      carousel.setAttribute('data-sk-pdp-reviews-placement', 'buybox');
    } else {
      if (carousel.parentElement !== gallery) {
        gallery.appendChild(carousel);
      }
      carousel.setAttribute('data-sk-pdp-reviews-placement', 'gallery');
    }
  }

  function initReviewsCarousel(root) {
    placeReviewsCarousel(root);

    var carousel = root.querySelector('[data-sk-pdp-reviews-carousel]');
    if (!carousel || carousel.dataset.skReviewsInit === 'true') return;
    carousel.dataset.skReviewsInit = 'true';

    var track = carousel.querySelector('[data-sk-pdp-reviews-track]');
    var viewport = carousel.querySelector('.sk-pdp-reviews-carousel__viewport');
    var dots = carousel.querySelectorAll('[data-sk-pdp-reviews-dot]');
    var slides = track ? track.querySelectorAll('.sk-pdp-reviews-carousel__slide') : [];
    if (!track || slides.length < 2 || !dots.length) return;

    var index = 0;
    var total = slides.length;
    var autoplayTimer = null;
    var autoplayDelay = 6000;
    var swipeThreshold = 40;
    var touchStartX = 0;
    var touchCurrentX = 0;
    var touchStartY = 0;
    var isDragging = false;
    var isHorizontalSwipe = false;

    function setTrackTransform(percent, animate) {
      track.style.transition = animate === false ? 'none' : '';
      track.style.transform = 'translateX(' + percent + '%)';
    }

    function goTo(nextIndex) {
      index = (nextIndex + total) % total;
      track.classList.remove('is-dragging');
      setTrackTransform(-index * 100, true);
      dots.forEach(function (dot, i) {
        var active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function startAutoplay() {
      stopAutoplay();
      autoplayTimer = window.setInterval(function () {
        goTo(index + 1);
      }, autoplayDelay);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        window.clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function startDrag(clientX, clientY) {
      stopAutoplay();
      isDragging = true;
      isHorizontalSwipe = false;
      touchStartX = clientX;
      touchCurrentX = clientX;
      touchStartY = clientY;
      track.classList.add('is-dragging');
      setTrackTransform(-index * 100, false);
    }

    function moveDrag(clientX, clientY, preventScroll) {
      if (!isDragging) return;

      var deltaX = clientX - touchStartX;
      var deltaY = clientY - touchStartY;

      if (!isHorizontalSwipe) {
        if (Math.abs(deltaX) < 8 && Math.abs(deltaY) < 8) return;
        if (Math.abs(deltaY) > Math.abs(deltaX)) {
          isDragging = false;
          track.classList.remove('is-dragging');
          setTrackTransform(-index * 100, true);
          startAutoplay();
          return;
        }
        isHorizontalSwipe = true;
      }

      if (preventScroll) preventScroll();
      touchCurrentX = clientX;
      var width = viewport.offsetWidth || 1;
      var deltaPercent = (deltaX / width) * 100;
      var nextPercent = -index * 100 + deltaPercent;

      if ((index === 0 && deltaPercent > 0) || (index === total - 1 && deltaPercent < 0)) {
        nextPercent = -index * 100 + deltaPercent * 0.35;
      }

      setTrackTransform(nextPercent, false);
    }

    function endDrag() {
      if (!isDragging) return;
      isDragging = false;
      isHorizontalSwipe = false;
      track.classList.remove('is-dragging');

      var deltaX = touchCurrentX - touchStartX;
      if (Math.abs(deltaX) >= swipeThreshold) {
        goTo(deltaX < 0 ? index + 1 : index - 1);
      } else {
        goTo(index);
      }

      startAutoplay();
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.getAttribute('data-sk-pdp-reviews-dot'), 10) || 0);
        startAutoplay();
      });
    });

    carousel.addEventListener('mouseenter', stopAutoplay);
    carousel.addEventListener('mouseleave', startAutoplay);
    carousel.addEventListener('focusin', stopAutoplay);
    carousel.addEventListener('focusout', startAutoplay);

    if (viewport) {
      viewport.addEventListener('touchstart', function (event) {
        if (event.touches.length !== 1) return;
        startDrag(event.touches[0].clientX, event.touches[0].clientY);
      }, { passive: true });

      viewport.addEventListener('touchmove', function (event) {
        if (!isDragging || event.touches.length !== 1) return;
        moveDrag(event.touches[0].clientX, event.touches[0].clientY, function () {
          event.preventDefault();
        });
      }, { passive: false });

      viewport.addEventListener('touchend', endDrag);
      viewport.addEventListener('touchcancel', endDrag);

      viewport.addEventListener('mousedown', function (event) {
        if (event.button !== 0) return;
        startDrag(event.clientX, event.clientY);
      });

      window.addEventListener('mousemove', function (event) {
        if (!isDragging) return;
        moveDrag(event.clientX, event.clientY);
      });

      window.addEventListener('mouseup', endDrag);
    }

    goTo(0);
    startAutoplay();
  }

  function bindReviewsCarouselPlacement(root) {
    if (root.dataset.skReviewsPlacementBound === 'true') return;
    root.dataset.skReviewsPlacementBound = 'true';

    var mq = window.matchMedia('(max-width: 880px)');
    var onChange = function () {
      placeReviewsCarousel(root);
    };

    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', onChange);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(onChange);
    }
  }

  function syncGbuShopCta(root) {
    if (root.getAttribute('data-sk-section') !== 'shop') return;

    var cta = root.querySelector('[data-sk-add-to-cart]');
    if (!cta || !cta.dataset.ctaBase) return;

    var ctaContent = cta.querySelector('.sk-checkout-btn__content');
    if (!ctaContent) {
      ctaContent = document.createElement('span');
      ctaContent.className = 'sk-checkout-btn__content';
      cta.textContent = '';
      cta.appendChild(ctaContent);
      var loading = document.createElement('span');
      loading.className = 'sk-checkout-btn__loading';
      loading.setAttribute('aria-hidden', 'true');
      loading.innerHTML = '<span class="sk-checkout-btn__dots" aria-hidden="true"><span></span><span></span><span></span></span>';
      cta.appendChild(loading);
    }

    if (root.querySelector('.skg-shop--reset')) {
      ctaContent.textContent = cta.dataset.ctaBase;
      return;
    }

    var activeCard = root.querySelector('.sk-offer-card.active');
    var price = activeCard && activeCard.dataset.stickyPrice
      ? activeCard.dataset.stickyPrice
      : '';

    if (!price && activeCard) {
      var priceEl = activeCard.querySelector('.sk-offer-price');
      if (priceEl) {
        price = priceEl.textContent.replace(/\s*\/month/i, '').trim();
      }
    }

    ctaContent.textContent = price ? cta.dataset.ctaBase + ' - ' + price : cta.dataset.ctaBase;
  }

  function syncGalleryPrimaryImage(root) {
    var gallery = root.querySelector('[data-skg-gallery]');
    if (!gallery || !gallery.dataset.primaryDefaultD) return;

    var activeCard = root.querySelector('.sk-offer-card.active');
    var imageKey = activeCard && activeCard.dataset.galleryImage === 'bundle' ? 'bundle' : 'default';
    var desktopUrl = imageKey === 'bundle' && gallery.dataset.primaryBundleD
      ? gallery.dataset.primaryBundleD
      : gallery.dataset.primaryDefaultD;
    var mobileUrl = imageKey === 'bundle' && gallery.dataset.primaryBundleM
      ? gallery.dataset.primaryBundleM
      : gallery.dataset.primaryDefaultM;
    var thumbUrl = imageKey === 'bundle' && gallery.dataset.primaryBundleThumb
      ? gallery.dataset.primaryBundleThumb
      : gallery.dataset.primaryDefaultThumb;

    if (!desktopUrl) return;

    var primarySlide = gallery.querySelector('[data-skg-primary-slide]');
    if (primarySlide) {
      var primaryImg = primarySlide.querySelector('.skg-shop__main-img');
      var primarySource = primarySlide.querySelector('source[data-skg-primary-source-mobile]');
      if (primaryImg) {
        primaryImg.src = desktopUrl;
        primaryImg.removeAttribute('srcset');
        primaryImg.removeAttribute('sizes');
      }
      if (primarySource && mobileUrl) primarySource.srcset = mobileUrl;
    }

    var primaryThumb = gallery.querySelector('[data-skg-thumb][data-skg-slide="0"] img');
    if (primaryThumb && thumbUrl) {
      primaryThumb.src = thumbUrl;
      primaryThumb.removeAttribute('srcset');
    }

    var stickyOuter = document.getElementById('sk-sticky-atc-' + root.dataset.sectionId);
    if (stickyOuter) {
      var stickyImg = stickyOuter.querySelector('.sk-sticky-atc__image');
      if (stickyImg) {
        stickyImg.src = thumbUrl || desktopUrl;
        stickyImg.removeAttribute('srcset');
      }
    }

    if (typeof gallery._skgGoTo === 'function') {
      gallery._skgGoTo(0);
    }
  }

  function initGbuShopGallery(root) {
    var gallery = root.querySelector('[data-skg-gallery]');
    if (!gallery || gallery.dataset.skgGalleryInit === 'true') return;

    var viewport = gallery.querySelector('[data-skg-gallery-viewport]');
    var track = gallery.querySelector('[data-skg-gallery-track]');
    var slides = track ? track.querySelectorAll('[data-skg-slide]') : [];
    var thumbs = gallery.querySelectorAll('[data-skg-thumb]');

    if (!viewport || !track || slides.length < 2) {
      gallery.dataset.skgGalleryInit = 'true';
      return;
    }

    gallery.dataset.skgGalleryInit = 'true';

    var index = 0;
    var total = slides.length;
    var swipeThreshold = 40;
    var touchStartX = 0;
    var touchCurrentX = 0;
    var touchStartY = 0;
    var isDragging = false;
    var isHorizontalSwipe = false;

    function slideWidth() {
      return viewport.offsetWidth || 1;
    }

    function setTrackTransform(offsetPx, animate) {
      track.style.transition = animate === false ? 'none' : '';
      track.style.transform = 'translateX(' + offsetPx + 'px)';
    }

    function syncThumbs() {
      thumbs.forEach(function (thumb) {
        var slideIndex = parseInt(thumb.getAttribute('data-skg-slide'), 10) || 0;
        var active = slideIndex === index;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    function goTo(nextIndex) {
      index = Math.max(0, Math.min(total - 1, nextIndex));
      track.classList.remove('is-dragging');
      setTrackTransform(-index * slideWidth(), true);
      syncThumbs();
    }

    function startDrag(clientX, clientY) {
      isDragging = true;
      isHorizontalSwipe = false;
      touchStartX = clientX;
      touchCurrentX = clientX;
      touchStartY = clientY;
      track.classList.add('is-dragging');
      setTrackTransform(-index * slideWidth(), false);
    }

    function moveDrag(clientX, clientY, preventScroll) {
      if (!isDragging) return;

      var deltaX = clientX - touchStartX;
      var deltaY = clientY - touchStartY;

      if (!isHorizontalSwipe) {
        if (Math.abs(deltaX) < 8 && Math.abs(deltaY) < 8) return;
        if (Math.abs(deltaY) > Math.abs(deltaX)) {
          isDragging = false;
          track.classList.remove('is-dragging');
          setTrackTransform(-index * slideWidth(), true);
          return;
        }
        isHorizontalSwipe = true;
      }

      if (preventScroll) preventScroll();
      touchCurrentX = clientX;
      var width = slideWidth();
      var nextPx = -index * width + deltaX;

      if ((index === 0 && deltaX > 0) || (index === total - 1 && deltaX < 0)) {
        nextPx = -index * width + deltaX * 0.35;
      }

      setTrackTransform(nextPx, false);
    }

    function endDrag() {
      if (!isDragging) return;
      isDragging = false;
      isHorizontalSwipe = false;
      track.classList.remove('is-dragging');

      var deltaX = touchCurrentX - touchStartX;
      if (Math.abs(deltaX) >= swipeThreshold) {
        goTo(deltaX < 0 ? index + 1 : index - 1);
      } else {
        goTo(index);
      }
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        goTo(parseInt(thumb.getAttribute('data-skg-slide'), 10) || 0);
      });
    });

    viewport.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        goTo(index - 1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        goTo(index + 1);
      }
    });

    viewport.addEventListener('touchstart', function (event) {
      if (event.touches.length !== 1) return;
      startDrag(event.touches[0].clientX, event.touches[0].clientY);
    }, { passive: true });

    viewport.addEventListener('touchmove', function (event) {
      if (!isDragging || event.touches.length !== 1) return;
      moveDrag(event.touches[0].clientX, event.touches[0].clientY, function () {
        event.preventDefault();
      });
    }, { passive: false });

    viewport.addEventListener('touchend', endDrag);
    viewport.addEventListener('touchcancel', endDrag);

    viewport.addEventListener('mousedown', function (event) {
      if (event.button !== 0) return;
      event.preventDefault();
      startDrag(event.clientX, event.clientY);
    });

    window.addEventListener('mousemove', function (event) {
      if (!isDragging) return;
      moveDrag(event.clientX, event.clientY);
    });

    window.addEventListener('mouseup', endDrag);
    window.addEventListener('resize', function () {
      goTo(index);
    });

    gallery._skgGoTo = goTo;
    goTo(0);
  }

  function initPdpBuybox(root) {
    if (!root || root.dataset.skInitialized === 'true') return;
    root.dataset.skInitialized = 'true';

    var offerCards = root.querySelectorAll('.sk-offer-card');
    if (offerCards.length && !root.querySelector('.sk-offer-card.active')) {
      offerCards[0].classList.add('active');
    }

    offerCards.forEach(function (card) {
      card.addEventListener('click', function () {
        offerCards.forEach(function (c) {
          c.classList.remove('active');
        });
        card.classList.add('active');
        syncStickyBar(root);
        syncGbuShopCta(root);
        syncGalleryPrimaryImage(root);
      });
    });

    var addToCartBtn = root.querySelector('[data-sk-add-to-cart]');
    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', function () {
        if (addToCartBtn.classList.contains('is-loading')) return;
        var buttons = getCheckoutButtons(root);
        performCheckout(root, buttons);
      });
    }

    var subToggle = root.querySelector('.sk-sub-toggle');
    if (subToggle) {
      subToggle.addEventListener('click', function () {
        subToggle.classList.toggle('checked');
      });
    }

    syncStickyBar(root);
    syncGbuShopCta(root);
    syncGalleryPrimaryImage(root);
    initGbuShopGallery(root);
    initStickyBar(root);
    bindReviewsCarouselPlacement(root);
    initReviewsCarousel(root);
  }

  function initAll() {
    document.querySelectorAll('[data-sk-section="pdp-buybox"], [data-sk-section="shop"]').forEach(initPdpBuybox);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-sk-section="pdp-buybox"], [data-sk-section="shop"]');
    if (root) {
      root.dataset.skInitialized = 'false';
      root.dataset.skReviewsPlacementBound = 'false';
      var reviewsCarousel = root.querySelector('[data-sk-pdp-reviews-carousel]');
      if (reviewsCarousel) reviewsCarousel.dataset.skReviewsInit = 'false';
      var gallery = root.querySelector('[data-skg-gallery]');
      if (gallery) gallery.dataset.skgGalleryInit = 'false';
      var stickyOuter = document.getElementById('sk-sticky-atc-' + root.dataset.sectionId);
      if (stickyOuter) {
        if (typeof stickyOuter.__skStickyCleanup === 'function') {
          stickyOuter.__skStickyCleanup();
        }
        stickyOuter.dataset.skStickyInit = 'false';
      }
      initPdpBuybox(root);
    }
  });

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    fetch('/cart/clear.js', { method: 'POST' }).finally(function () {
      window.location.reload();
    });
  });
})();

document.addEventListener('click', async function (e) {
  var btn = e.target.closest('.promo-code-copy');
  if (!btn) return;

  var code = btn.dataset.copyCode;
  var tooltip = btn.querySelector('.promo-tooltip');

  try {
    await navigator.clipboard.writeText(code);
    tooltip.textContent = 'Copied!';
    tooltip.style.opacity = '1';
    tooltip.style.visibility = 'visible';
    setTimeout(function () { tooltip.textContent = 'Copy Code'; }, 2000);
  } catch (_) {}
});
